import { render, staticRenderFns } from "./explore-leg.vue?vue&type=template&id=db1b2018&"
import script from "./explore-leg.vue?vue&type=script&lang=js&"
export * from "./explore-leg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "explore-leg.vue"
export default component.exports